<template>
    <BaseLayout>
        <TransitionEffect>
            <NewPostModal
                v-if="newPostModal"
                @close="newPostModal=false"/>
        </TransitionEffect>

        <TransitionEffect
            v-if="!loading"
            name="simpleFade"
            :appear="true">
            <BlurredBackground
                :image="drafts[0].cover"/>
        </TransitionEffect>

        <div class="buttons">
            <Button class="upload"
                appearance="cta"
                size="fullWidth"
                prefixIcon="add_circle"
                @click="newPostModal=true">
                {{ siteContent.newPost }}
            </Button>
            <Button class="drafts"
                appearance="secondary"
                size="fullWidth"
                prefixIcon="edit"
                url="/blog">
                {{ siteContent.live }}
            </Button>
        </div>
        
        <Main>
            <FeedSkeleton
                v-if="loading"/>
            <PostFeed class="feed"
                v-else-if="drafts"
                :posts="drafts"/>
                
            <div class="empty"
                v-else>
                <div class="emoji">
                    👨🏻‍🚀
                </div>
                {{ siteContent.lowFrequencyOfMatter }}
            </div>

            <div v-view="handleView">
                <FeedSkeleton v-if="!draftsReachedBottom"/>
            </div>
        </Main>
    </BaseLayout>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import BaseLayout   from '@/components/layout/main/BaseLayout'
    import FeedSkeleton from '@/components/layout/main/FeedSkeleton'
    import PostFeed     from '@/components/blog/main/PostFeed'
    import NewPostModal from '@/components/blog/main/NewPostModal'
    import Main         from '@/components/layout/main/Main'

    export default {
        name: 'Unpublished',
        components: {
            BaseLayout,
            NewPostModal,
            Main,
            FeedSkeleton,
            PostFeed
        },
        data () {
            return {
                loading: true,
                newPostModal: false,
            }
        },
        computed: {
            ...mapState('blog',['drafts','draftsReachedBottom']),

            lastVisible() {
                return this.drafts[this.drafts.length - 1]
            }
        },
        methods: {
            ...mapActions('blog',['fetchPosts','fetchPostsAfter','setDraftsReachedBottomToDefault']),

            async handleView(event) {
                if(event.type === 'enter' && !this.loading) {
                    await this.fetchPostsAfter({
                        visibility:  false,
                        commitName: 'addDraftPosts',
                        lastVisible: this.lastVisible,
                        limit:       2
                    })
                }
            },
        },
        async mounted() {
            if (this.permissions.isAdmin || this.permissions.isWriter) {
                this.setDraftsReachedBottomToDefault()

                if(this.drafts.length === 0) {
                    await this.fetchPosts({
                        visibility:  false,
                        commitName: 'setDraftPosts',
                        limit:       4
                    })
                }

                this.loading = false
            } else {
                this.$router.push('/blog')
            }
        },
        metaInfo: {
            title: 'Drafts | Creatillo',
            meta: [
                { name: 'robots', content: 'noindex' }
            ]
        }
    }
</script>

<style scoped lang="scss">
    @import '../scss/variables';

    .feed {
        margin-top: 0;
        z-index: 1;
    }

    .empty {
        margin-top: 2rem;
        text-align: center;
    }

    .emoji {
        font-size: 4rem;
        margin-bottom: 1rem;
    }

    .buttons {
        display: flex;
        align-self: center;
        width: 100%;
        margin-bottom: 2rem;
        max-width: 28rem;
    }

    .upload {
        margin-right: 1rem;
    }
</style>